var baseURL = ''
// if (process.env.NODE_ENV == "development") {
//     // baseURL = 'http://192.168.1.196:8000';
//     baseURL = 'http://192.168.1.195:8888';
// } else if (process.env.NODE_ENV == "production") {
//     if (window.location.host.indexOf('pre-') > -1) {
//         axios.defaults.baseURL = window.location.protocol + "//pre-api.dazuhang.com"
//     } else if (window.location.host.indexOf('zulin') > -1) {
//         axios.defaults.baseURL = "https://hsfx-api.dazuhang.com"
//     } else {
//         axios.defaults.baseURL = window.location.protocol + "//api.dazuhang.com"
//     }
// }
export default baseURL;


// WEBPACK FOOTER //
// ./src/api/baseUrl.js